module.exports = __webpack_public_path__ + "img/dokyo.29b4ae39.png";